import { render, staticRenderFns } from "./RecipeCollectionListView.vue?vue&type=template&id=0260e163&scoped=true"
import script from "./RecipeCollectionListView.vue?vue&type=script&lang=js"
export * from "./RecipeCollectionListView.vue?vue&type=script&lang=js"
import style0 from "./RecipeCollectionListView.vue?vue&type=style&index=0&id=0260e163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0260e163",
  null
  
)

export default component.exports